import ScalarComboboxOption_vue_vue_type_script_setup_true_lang_default from "./ScalarComboboxOption.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarCombobox/ScalarComboboxOption.vue
var ScalarComboboxOption_default = ScalarComboboxOption_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarComboboxOption_default as default };

//# sourceMappingURL=ScalarComboboxOption.vue.js.map